export default __webpack_public_path__ + "assets/ico_step_9-0c1cf78a.svg";